import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormLAGO } from "../Models/Forms/IFormLAGO";


@Injectable()
export class FormLAGOService  extends  BaseService {

  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string)
  {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormLAGO(id: number) {
    return this._http.get(this._baseUrl + "api/FormLAGO/" + id)
      .map((response: IFormLAGO) => response as IFormLAGO)
      .catch(this.errorHandler);
  }

  insertUpdateFormLAGO(formLAGODetails: IFormLAGO) {
    return this._http.post(this._baseUrl + 'api/FormLAGO', formLAGODetails)
      .map((response: IFormLAGO) => response as IFormLAGO)
      .catch(this.errorHandler);
  }

  deleteLAGO(id) {
    return this._http.delete(this._baseUrl + "api/FormLAGO" + id)
      .map((response: IFormLAGO) => response as IFormLAGO)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
  
}


